import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import config from 'config'
import { withHandlers, compose, lifecycle } from 'recompose'

import * as actions from 'modules/org/actions'
import { updateUserProperties, fetchUser } from 'modules/user/actions'
import * as UserSelectors from 'modules/user/selectors'
import { fetchProfile } from 'modules/profile/actions'
import { getGlobalHandle } from 'modules/profile/selectors'
import { page, track } from 'utils/trackingUtils'
import { api } from 'modules/user/api'

import ExtensionStep from './component'

const mapStateToProps = (state) => {
  return {
    isSSOProvisionedFlow: UserSelectors.isSSOProvisionedFlow(state),
    userId: UserSelectors.getUserId(state),
    profileHandle: `${config.PROFILES_WEB_URL}${getGlobalHandle(state)}/meeting`
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    updateOrgProperties: actions.updateOrgProperties,
    updateUserProperties,
    fetchUser,
    fetchProfile,
  }, dispatch),
})

const finishMeetingsDemoStep = async(props, method) => {
  track('Onboarding Meeting Demo Completed', {
    context: 'calendar-seat-onboarding',
    isSSO: props.isSSOProvisionedFlow,
    method
  })
  if (props.isSSOProvisionedFlow) {
    props.actions.updateUserProperties({
      properties: {
        IS_JIT_PROVISIONED_USER : false,
      },
    })
  }
  await api.setAvailability(props.userId, 'AVAILABLE')

  track('Onboarding Completed', {
    context: 'calendar-seat-onboarding',
    isSSO: props.isSSOProvisionedFlow,
  })

  if (method === 'meeting-demo') {
    window.open(props.profileHandle, '_blank', 'location=0,status=0,width=1080,height=680')
    setTimeout(() => {
      window.location.replace(`${config.CUSTOMER_WEB_URL}/meetings`)
    }, 500)
  } else {
    window.location.replace(`${config.CUSTOMER_WEB_URL}/meetings`)
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      page('Onboarding Meeting Demo', {
        context: 'calendaring-seat-onboarding',
      })
      if (!this.props.userId) {
        this.props.actions.fetchUser()
      } else {
        this.props.actions.fetchProfile()
      }
    },
    componentDidUpdate(prevProps) {
      if (!!this.props.userId && !this.props.profileHandle) {
        this.props.actions.fetchProfile()
      }
    }
  }),
  withHandlers({
    onDemoCTAClick: props => () => {
      finishMeetingsDemoStep(props, 'meeting-demo')
    },
    onContinueClick: props => () => {
      finishMeetingsDemoStep(props, 'skipped-demo')
    },
  }),
)(ExtensionStep)



// WEBPACK FOOTER //
// ./src/layouts/MeetingsDemoStep/index.js